var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 25.1667C22.9998 23.0449 22.157 21.0101 20.6567 19.5098C19.1564 18.0095 17.1216 17.1667 14.9998 17.1667M14.9998 17.1667C12.8781 17.1667 10.8433 18.0095 9.34298 19.5098C7.84269 21.0101 6.99984 23.0449 6.99984 25.1667M14.9998 17.1667C17.9454 17.1667 20.3332 14.7789 20.3332 11.8333C20.3332 8.88782 17.9454 6.5 14.9998 6.5C12.0543 6.5 9.6665 8.88782 9.6665 11.8333C9.6665 14.7789 12.0543 17.1667 14.9998 17.1667ZM28.3332 14.5C28.3332 21.8638 22.3636 27.8333 14.9998 27.8333C7.63604 27.8333 1.6665 21.8638 1.6665 14.5C1.6665 7.1362 7.63604 1.16667 14.9998 1.16667C22.3636 1.16667 28.3332 7.1362 28.3332 14.5Z",
    stroke: "#1750A4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.7a9e83a9157f3e8330615f0a986d941a.svg";
export { ForwardRef as ReactComponent };